import { ref, onMounted, computed } from 'vue';
import { API, graphqlOperation } from 'aws-amplify';
import { awsNow, formatAwsTimestamp, logintest } from '@/lib/common';

import { getCompany, listCnbcChannels } from '@/graphql/queries';

import { config } from '@/config';
import { User } from '@/@types/d';

export const NkCnbcMenuComponentSetup = () => {
  const currentUser = ref({} as User);
  const isloading = ref(false);
  const loggedIn = ref(false); 

  const channels = ref([]);

  onMounted(() => {
    logintest(initView, clearView, {user:currentUser, state:loggedIn});
  });

  const initView = async () => {
    isloading.value = true;

    await queryChannels(currentUser.value.company);

    isloading.value = false;

  };
  const clearView = () => {
    channels.value = [];
  };

  // 視聴可能なチャンネルリスト query
  const queryChannels = async (company: string|undefined) => {
    if(!company) return;

    // 先にcompanyを取得して、planを引き当てる
    const res:any = await API.graphql(graphqlOperation(getCompany, {id: company}));
    if(res.data?.getCompany.cnbcPlan) {
      const plan = res.data?.getCompany.cnbcPlan || '';
      const params = {
        filter: {
          plans: {contains: plan}
        },
        limit: config.NKCNBC_CHANNEL_LIMIT
      };
      const resChannels:any = await API.graphql(graphqlOperation(listCnbcChannels, params));
      if(resChannels.data?.listCnbcChannels.items) {
        channels.value = resChannels.data.listCnbcChannels.items;
      }
    }
  };

  const listChannels = ():any[] => {
    return channels.value.sort((a:any, b:any) => (b.latestTimestamp||0) - (a.latestTimestamp||0));
  };

  return {
    formatAwsTimestamp,
    listChannels,
  }
};
